import React from 'react';
import StatusWidget from './Statuswidget';
import ConnectionsWidget from './ConnectionsWidget';

// --- INÍCIO DA ALTERAÇÃO: Removido o Assistente de IA ---
const TaskSidebar = ({ task }) => {
    return (
        <div className="lg:col-span-2 space-y-6">
            <StatusWidget task={task} />
            <hr className="border-white/10" />
            <ConnectionsWidget task={task} />
        </div>
    );
};
// --- FIM DA ALTERAÇÃO ---

export default TaskSidebar;